import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { JwtService } from '@gray/domain/http/jwt.service';
import { environment } from '../../../environments/environment';

/** What the gateway wraps every broadcast in. */
export interface ICoachChatEvent {
  event: 'message' | 'read';
  data: any;
}

/**
 * The live half of the coach chat. The gateway tells coaches and students apart by the header they
 * connect with, so this one presents the coach token; the student app connects with its own.
 *
 * Not connected on creation: CoachChatUnreadService opens it once the panel layout is up and keeps
 * it open for the menu badge, the inbox and the messages tab alike.
 */
@Injectable({providedIn: 'root'})
export class CoachChatSocketService extends Socket {

  constructor(
    private jwtService: JwtService,
  ) {
    super({
      url: environment.wsUrl,
      options: {
        autoConnect: false,
        reconnection: true,
        path: '/coach-chat',
        extraHeaders: {'coach-authorization': jwtService.getToken() ?? ''},
      },
    });
  }

  /** Connects with the current token; the one read at construction may belong to an earlier login. */
  connectWithCurrentToken() {
    this.ioSocket.io.opts.extraHeaders = {'coach-authorization': this.jwtService.getToken() ?? ''};
    this.connect();
  }

  /** Emitted once the gateway has resolved who is connecting; joining before it is racy. */
  onReady(): Observable<any> {
    return this.fromEvent('ready');
  }

  onEvent(): Observable<ICoachChatEvent> {
    return this.fromEvent<ICoachChatEvent>('coach-chat');
  }

  joinConversation(studentId: number) {
    this.emit('join', {targetId: studentId});
  }

  markRead(studentId: number) {
    this.emit('mark-read', {targetId: studentId});
  }
}
